import { Filter, ListFilter, NumberFilter, StringFilter } from '@data/filter/filter';
import { Stop } from '@data/stop/stop.model';

const jobsAmount = (s: Stop): number =>
  s?.jobsData ? Object.keys(s.jobsData).length : (s?.jobs?.length ?? 0);

export namespace AttendantsFilter {
  export function createInitialAttendantFilterState(state: any[]): Filter<any, any>[] {
    return [
      new StringFilter<Stop>(
        'Firmenname',
        (it) => it.companyData?.name,
        state[0]?.isActive,
        state[0]?.value,
        state[0]?.options,
      ),
      new StringFilter<Stop>(
        'Stand',
        (it) => it.boothNr,
        state[1]?.isActive,
        state[1]?.value,
        state[1]?.options,
      ),
      new NumberFilter<Stop>(
        'Jobs',
        (it) => jobsAmount(it),
        state[2]?.isActive,
        state[2]?.value,
        state[2]?.options,
      ),
      new ListFilter<Stop, boolean>(
        [true, false],
        'Anwesend',
        (it) => !it.exited,
        (exited) => 'COMMON.' + (exited ? 'yes' : 'no'),
        state[3]?.isActive,
        state[3]?.value,
        state[3]?.options,
      ),
      new ListFilter<Stop, boolean>(
        [true, false],
        'Überprüft',
        (it) => it.checked,
        (checked) => 'COMMON.' + (checked ? 'yes' : 'no'),
        state[4]?.isActive,
        state[4]?.value,
        state[4]?.options,
      ),
    ];
  }
}
